import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actionTypes from "../ActionTypes/index";

import {
  saveTeamVideoSuccess,
  saveTeamVideoFailure,
  updateTeamVideoSuccess,
  updateTeamVideoFailure,
  deleteTeamVideoSuccess,
  deleteTeamVideoFailure,
  readTeamVideoSuccess,
  readTeamVideoFailure,
} from "./teamVideoActions";

import {
  saveTeamVideo,
  updateTeamVideo,
  deleteTeamVideo,
  readTeamVideos,
} from "./teamVideoAPI";

// ✅ Save Team Video
function* saveTeamVideoSaga(action) {
    try {
      const payload = action.payload; // now payload is the actual object
      const res = yield call(saveTeamVideo, payload); // API will convert to FormData
  
      if (res?.type === 1) {
        yield put(saveTeamVideoSuccess(res.data));
        toast.success(res.message || "Team video saved successfully!");
        if (action.callback) action.callback({ type: 1, data: res.data });
      } else {
        throw new Error(res?.error || "Save failed");
      }
    } catch (error) {
      yield put(saveTeamVideoFailure(error.message));
      toast.error(error.message);
      if (action.callback) action.callback({ type: 0, error: error.message });
    }
  }
  

// ✅ Update Team Video
function* updateTeamVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(updateTeamVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(updateTeamVideoSuccess(res.data));
      toast.success(res.message || "Team video updated successfully!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else {
      throw new Error(res?.error || "Update failed");
    }
  } catch (error) {
    yield put(updateTeamVideoFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ Delete Team Video
function* deleteTeamVideoSaga(action) {
  try {
    const res = yield call(deleteTeamVideo, action.payload);

    if (res?.type === 1) {
      yield put(deleteTeamVideoSuccess(action.payload));
      toast.success(res.message || "Team video deleted successfully!");
      if (action.callback) action.callback({ type: 1, _id: action.payload.memberVideoObjId });
    } else {
      throw new Error(res?.error || "Delete failed");
    }
  } catch (error) {
    yield put(deleteTeamVideoFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ Read Team Videos
function* readTeamVideosSaga(action) {
  try {
    const res = yield call(readTeamVideos, action.payload);

    if (res?.type === 1) {
      yield put(readTeamVideoSuccess(res.data));
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else {
      throw new Error(res?.error || "Read failed");
    }
  } catch (error) {
    yield put(readTeamVideoFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ Watcher
export default function* teamVideoWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_TEAM_VIDEO_REQUEST, saveTeamVideoSaga);
  yield takeLatest(actionTypes.UPDATE_TEAM_VIDEO_REQUEST, updateTeamVideoSaga);
  yield takeLatest(actionTypes.DELETE_TEAM_VIDEO_REQUEST, deleteTeamVideoSaga);
  yield takeLatest(actionTypes.READ_TEAM_VIDEO_REQUEST, readTeamVideosSaga);
}
